import React, { useState, useEffect } from "react"
import Leaflet from "leaflet"
import { MapContainer, TileLayer, Marker, Popup, LayersControl } from "react-leaflet"
import "leaflet/dist/leaflet.css"

import axios from 'axios';
import { SAMPLINGPOINTS, WQDATA1 } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

import bl from "assets/icons/pin1.png";
import rd from "assets/icons/pin2.png";
import gn from "assets/icons/pin3.png";
const SPMap = () => {
   

    const centerPosition = [9.583397, 44.083651]
    const [points, setPoints] = useState([])
    const [isloading, setIsloading] = useState(false);

    const redPoint = Leaflet.icon({
      iconUrl:rd,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })
    const bluePoint = Leaflet.icon({
      iconUrl:bl,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })
    const greenPoint = Leaflet.icon({
      iconUrl:gn,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })

    

    const fetchData = () => {
        let ac = []
        axios.get(SAMPLINGPOINTS, Config).then((r)=>{ 
            r.data.map((x)=>{ 
              let qd = []
              //axios.get(`${WQDATA1}?point${x.id}`, Config).then((rd)=>{ 
              //  qd = (rd.data)
              //}).catch((qe)=>{ console.log(qe)}) 
              ac.push({cordinates: [x.lat,x.lon], name: x.name, type: x.type, qdata: qd}); 
           }) ;
            setPoints(ac)
        }).catch((e)=>{  console.log(e); });
    }
    useEffect(() => {
        setIsloading(true)
        fetchData();
        setIsloading(false)
    },[]);
    
    
    return (
      <LoadingOverlay
        active={isloading}
        spinner={<BounceLoader />}
        text='Please wait...'
        >
          <MapContainer
            center={centerPosition}
            zoom={9}
            style={{ height: "700px" }}
            attributionControl={true}
            zoomControl={false}
            doubleClickZoom={true}
            scrollWheelZoom={true}
            dragging={true}
            animate={true}
            easeLinearity={0.35}
          >
            <LayersControl position="topright">
          <LayersControl.BaseLayer name="Satellite">
            <TileLayer
              attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
              url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
              id="mapbox/satellite-v9" 
              accessToken={process.env.REACT_APP_APIKEY}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer checked name="Street">
            <TileLayer
                attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                id="mapbox/streets-v11" 
                accessToken={process.env.REACT_APP_APIKEY}
              />
          </LayersControl.BaseLayer>
          </LayersControl>
        
            {points && (points.length > 0) && (
                points.map((p,k) => ( 
                    <Marker key={k} position={p.cordinates} icon={(p.type == 'Raw Water')?bluePoint:greenPoint} >
                        <Popup>
                            <strong>{p.name}</strong><br/>{p.type}
                        </Popup>
                    </Marker>
                ))
            )}
          </MapContainer>
        </LoadingOverlay>
    )
  }
export default SPMap;
